module.exports = __webpack_public_path__ + "img/dy_p5_img_2.f0a1ba73.png";